import { HttpClient } from '@angular/common/http';
import { INavMenuItem } from '../../models/interfaces/IInclusion';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SymphonyDrilldownFacade } from '../../facades/symphony-drilldown/symphony-drilldown.facade';
import { endPoints } from '../../constants/endpoints';

@Injectable({
  providedIn: 'root',
})
export class MenuitemsService {
  constructor(private readonly http: HttpClient) {}

  onMenuItemClick(
    menuItem: INavMenuItem,
    symphonyDrilldownFacade: SymphonyDrilldownFacade,
  ): Observable<boolean> {
    return new Observable((closeMenu) => {
      if (menuItem?.id === 'ReportsV2') {
        this.http
          .get(endPoints.scsaccount.domoReportsAuth.URI)
          .subscribe((session: any) => {
            if (session.success) {
              window.open(session.sessionUrl, '_self');
              closeMenu.next(true);
            }
          });
      } else if (menuItem?.id === 'RequestQuote') {
        symphonyDrilldownFacade.navigateToSymphonyDashboardAndOpenQuote();
        closeMenu.next(true);
      } else if (menuItem?.routerLink) {
        symphonyDrilldownFacade.navigateToSymphonyPageUrl(menuItem?.routerLink);
        closeMenu.next(true);
      } else {
        closeMenu.next(false);
      }
    });
  }
}
